import { createAction, props } from '@ngrx/store';
import { IDebitsData, IDebitsModel } from '@partners/api';

export class DebitsActions {
  static reset = createAction('[Debits] Reset State');
  static updateModel = createAction('[Debits] Update Model', props<{ model: IDebitsModel }>());
  static load = createAction('[Debits] Load');
  static loadSuccess = createAction('[Debits] Load Success', props<{ model: IDebitsModel; data: IDebitsData }>());
  static loadFailure = createAction('[Debits] Load Failure', props<{ error: any }>());
  static submit = createAction('[Debits] Submit');
  static submitSuccess = createAction('[Debits] Submit Success', props<{ model: IDebitsModel; data: IDebitsData }>());
  static submitFailure = createAction('[Debits] Submit Failure', props<{ error: any }>());
}
